import { ReactNode, memo, CSSProperties } from 'react'
import styles from './ListData.module.css'
import { CardInfo, CardsHeader } from './CardsHeader'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { IconProp } from '@fortawesome/fontawesome-svg-core'


export const ListData = memo(({ title, items, info, footer }: ListDataProps) => {
    return (
        <section className={styles.card}>
            <CardsHeader title={title} />
            <main className={styles.itemsContainer}>
                {items.map(({ icon, label, value }, i) => (
                    <div key={i} className={styles.item}>
                        <div className={styles.col1}>
                            <FontAwesomeIcon
                                onClick={icon.onClick}
                                icon={icon.icon}
                                style={icon.style}
                                className={`${styles.icon} ${icon.onClick ? styles.clickable : styles.unClickable}`}
                                title={icon.title}
                                        />
                            <span
                                onClick={label.onClick}
                                style={label.style}
                                className={`${styles.label} ${label.onClick ? styles.clickable : styles.unClickable}`}
                                title={label.title}
                            >
                                {label.text}
                            </span>
                        </div>
                        <div>
                            <span
                                className={`${styles.value} ${value.onClick ? styles.clickable : styles.unClickable}`}
                                onClick={value.onClick}
                                title={value.title}
                            >
                                {value.text}
                            </span>
                        </div>
                    </div>
                ))}
            </main>
            {footer && <footer className={styles.footer}>{footer}</footer>}
            <CardInfo info={info} />
        </section>
    )
})

// Interface
export interface ListDataProps {
    title: ReactNode
    footer?: ReactNode
    info: string
    items: {
        icon: {
            icon: IconProp
            title?: string
            style?: CSSProperties
            onClick?: () => void
        }
        label: {
            text: ReactNode
            title?: string
            style?: CSSProperties
            onClick?: () => void
        }
        value: {
            text: ReactNode
            title?: string
            style?: CSSProperties
            onClick?: () => void
        }
    }[]
}
